import React from "react";
import BaseField from "./BaseField";

export default function MultipleChoiceField({
  field,
  value,
  setValue,
  renderInlineChildren,
  openViewer,
  previewMode = false,
}) {
  const required = !!field.required;
  const label = field.label || "Multiple choice";

  const options = field.config?.options || [];
  const isMulti = !!field.config?.multi;
  const allowOther = !!field.config?.allowOther;

  // Normalize value
  const selected = isMulti
    ? Array.isArray(value) ? value : []
    : typeof value === "string" ? value : "";

  // --- select handler ---
  const toggleOption = (label) => {
    if (!isMulti) {
      setValue(label);
      return;
    }

    const set = new Set(selected);
    set.has(label) ? set.delete(label) : set.add(label);
    setValue(Array.from(set));
  };

  return (
    <BaseField
      field={field}
      value={value}
      setValue={setValue}
      openViewer={openViewer}
      renderInlineChildren={renderInlineChildren}
      previewMode={previewMode}
    >
      {/* Label */}
      <h3 className="text-gray-800 dark:text-gray-100 text-lg font-bold mb-3 text-center">
        {label} {required && <span className="text-orange-500">*</span>}
      </h3>

      {/* Options */}
      <div className="flex flex-row flex-wrap gap-2 justify-center mt-2">
        {options.map((o) => {
          const active = isMulti
            ? selected.includes(o.label)
            : selected === o.label;

          return (
            <button
              key={o.id}
              type="button"
              onClick={() => toggleOption(o.label)}
              className="px-3 py-2 rounded-lg border font-semibold text-gray-800 dark:text-gray-100 transition-colors"
              style={{
                backgroundColor: active ? (o.color || "#e5e7eb") : "#fff",
                borderColor: active ? (o.color || "#e5e7eb") : "#d1d5db",
              }}
            >
              {o.label}{" "}
              <span className="text-gray-600 dark:text-gray-400">
                ({o.score ?? 0})
              </span>
            </button>
          );
        })}
      </div>

      {/* "Other" field */}
      {allowOther && (
        <input
          type="text"
          placeholder="Other..."
          value={
            typeof value === "string" &&
            !options.map((o) => o.label).includes(value)
              ? value
              : ""
          }
          onChange={(e) => setValue(e.target.value)}
          className="w-full border-2 border-orange-500 rounded-lg p-3 bg-white dark:bg-gray-700 text-center text-base text-gray-800 dark:text-gray-100 mt-3 focus:outline-none focus:ring-2 focus:ring-orange-400"
        />
      )}
    </BaseField>
  );
}
